import React, { useLayoutEffect, useState } from 'react';
import { InlineAlert, Toast, Typography } from 'br2s-ui-componentlibrary_r2_02';
import { axiosInstance } from '../../services/http';
import { ERROR_SEARCH } from '@/utilities/constants/constants';
interface IErrorHandler {
  type?: string;
  children: React.ReactNode | React.ReactNode[];
}

export const ErrorHandler = ({ type = 'toast', children }: IErrorHandler) => {
  const [isToastOpen, setIsToastOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  // using useLayoutEffect hook to run effect before first network call (getMessages)
  // istanbul ignore next
  useLayoutEffect(() => {
    const errorInterceptor = axiosInstance.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.status === 400) {
          setIsToastOpen(true);
          const errorCode = error.response?.data?.error?.errorCode;
          if (errorCode === ERROR_SEARCH.CODE) {
            setErrorMessage(ERROR_SEARCH.MESSAGE);
          } else {
            setErrorMessage(error.response?.data?.error?.errorDesc);
          }
        }

        return Promise.reject(error);
      }
    );

    return () => {
      axiosInstance.interceptors.response.eject(errorInterceptor);
    };
  }, []);

  const dismissToast = () => setIsToastOpen(false);

  return (
    <>
      {isToastOpen && type === 'toast' && (
        <Toast
          isDisplayed={isToastOpen}
          type="error"
          headline="Error"
          description={errorMessage}
          onDismissClick={dismissToast}
          onDismiss={dismissToast}
        />
      )}
      {isToastOpen && type === 'inline' && (
        <InlineAlert
          id="inline-alert-introduction"
          headline={'Error'}
          subHeadline=""
          type="error"
        >
          <Typography type="base" label={errorMessage} />
        </InlineAlert>
      )}
      {children}
    </>
  );
};
